import { Table as MaterialTable } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import React, { Component } from "react";
import config from "../../config";
import errorFunctions from "../../store/errorFunctions";
import "./Table.css";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";
import { Link } from "react-router-dom";
import { createBrowserHistory } from "history";
import LoadingPage from "../Loading/Loading";

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, headCells } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => {
          return (
            <TableCell
              key={headCell.id}
              sortDirection={orderBy === headCell.id ? order : false}
              style={{
                lineHeight: "1rem",
                boxSizing: "border-box",
              }}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(
                  headCell.id === "verificationStatus" ? "status" : headCell.id,
                )}
                style={{
                  fontSize: "12px",
                  color: "#777777",
                }}
              >
                {headCell.label}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

export default class Table extends Component {
  constructor(props) {
    super(props);

    this.state = {
      order: "desc",
      orderBy: "id",
      page: 0,
      rowsPerPage: 15,
      employee: null,
      showModal: false,
      showModalResetPassword: false,
      ticketID: 0,
      employeeID: 0,
      emailForReset: "",
      statusTicketType: "",
      modalStatus: false,
      modalCaption: "",
      rowPerPage: 15,
      pageNumber: 1,
      loading: false,
    };
  }

  componentDidMount() {
    // code to execute after component has mounted
    this.retrieveData({ pageNumber: 1, rowPerPage: 15 });
  }

  retrieveData = ({ urlTxt, rowPerPage = 15, pageNumber = 1, q } = {}) => {
    this.setState({ loading: true });

    let baseUrl = config.backendServer + "employee/";
    let params = {
      roles:
        "Staff,Admin,Approver,Service,Service Center Manager,Service Center Admin",
    };

    if (urlTxt) {
      baseUrl = urlTxt;
      params = {};
    } else {
      params.limit = rowPerPage;
      params.page = pageNumber;
      params.pagination = true;
    }

    if (q) {
      params.q = q;
    }

    this.props
      .protectedFetch(
        baseUrl,
        "GET",
        params,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        this.setState({
          employee: res?.results,
          totalEmployee: res?.count,
          nextPageEmploy: res?.next,
          prevPageEmploy: res?.previous,
          rowPerPage: rowPerPage || 10,
          pageNumber: pageNumber ?? 1,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("fail");
      });
  };

  onKeyDown = (e) => {
    if (e.key === "Enter") this.retrieveData({ q: this.state.searchFilter });
  };

  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === "asc";
    this.setState({
      order: isAsc ? "desc" : "asc",
      orderBy: property,
    });
  };

  handleChangePage = (event, newPage) => {
    let apiUrl = "";
    if (event.currentTarget.title === "Next page")
      apiUrl = this.state.nextPageEmploy;
    else apiUrl = this.state.prevPageEmploy;

    const pageNumber = newPage + 1;

    this.setState({
      pageNumber,
    });

    this.retrieveData({
      urlTxt: apiUrl,
      pageNumber,
      rowPerPage: this.state.rowPerPage,
    });
  };

  searchChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleChangeRowsPerPage = (event) => {
    const rowPerPage = parseInt(event.target.value, 10);
    this.setState({
      rowPerPage,
      pageNumber: 1,
    });
    this.retrieveData({ rowPerPage: rowPerPage, pageNumber: 1 });
  };

  handleDropDown = (e, id) => {
    let ticketID = id;
    let employeeID = e.target.value;
    this.setState({ showModal: true, employeeID, ticketID });
  };

  handleSubmitAssign = (event) => {
    event.preventDefault();
    let payload = {
      assigned_to: this.state.employeeID,
    };
    this.props
      .protectedFetch(
        config.backendServer + `ticket/${this.state.ticketID}/assign/`,
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        this.retrieveData({ rowPerPage: this.state.rowPerPage, pageNumber: 1 });
        // this.props.reloadMini(this.props.selectedbrandID);
        this.setState({ showModal: false });
      })
      .catch(() => {
        console.log("fail");
        this.setState({ showModal: false });
      });
  };

  handleOpenModalSendPassword = (email, modalCaption) => {
    this.setState({
      showModalResetPassword: true,
      emailForReset: email,
      modalCaption,
    });
  };

  handleSendVerification = (event) => {
    event.preventDefault();
    let payload = {
      email: this.state.emailForReset,
    };
    this.props
      .protectedFetch(
        `${config.backendServer}registration/resend-email/?brandId=${this.props.selectedbrandID}`,
        "POST",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then((response) => {
        console.log(response.status);
        if (response.detail === "ok") {
          this.setState({
            showModalResetPasswordSuccess: true,
            showModalResetPassword: false,
          });
        } else if (response.status === 409) {
          alert(`Email does not exist.`);
        } else {
          alert("Problem with system. Please refresh and try again later.");
        }
      })
      .catch(() => {
        console.log("fail");
        this.setState({ showModal: false });
      });
  };

  handleResetPassword = () => {
    let url = `${config.backendServer}password/staff/reset/`;

    if (this.props.selectedbrandID !== undefined) {
      url += `?brandId=${this.props.selectedbrandID}`;
    }

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: this.state.emailForReset,
      }),
    }).then((response) => {
      console.log(response.status);
      if (response.status === 200) {
        this.setState({ showModalResetPasswordSuccess: true });
      } else if (response.status === 409) {
        alert(`Email does not exist.`);
      } else {
        alert("Problem with system. Please refresh and try again later.");
      }
    });
  };
  handleStatusTicketTypeModal = (e, id) => {
    e.preventDefault();
    this.setState({
      modalStatus: true,
      statusTicketType: e.target.value,
      ticketID: id,
    });
  };

  handleChangeStatusTicketType = (e) => {
    e.preventDefault();

    let payload = {
      ticket_type: this.state.statusTicketType,
    };
    this.props
      .protectedFetch(
        config.backendServer + `ticket/${this.state.ticketID}/change-type/`,
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        this.retrieveData({ rowPerPage: this.state.rowPerPage, pageNumber: 1 });
        // this.props.reloadMini(this.props.selectedbrandID);
        this.setState({ modalStatus: false });
      })
      .catch(() => {
        console.log("fail");
        this.setState({ modalStatus: false });
      });
  };

  renderTicketType = (status, value) => {
    return value;
  };

  handleCancel = () => {
    this.retrieveData({ rowPerPage: this.state.rowPerPage, pageNumber: 1 });
    // this.props.reloadMini(this.props.selectedbrandID);
    this.setState({
      modalStatus: false,
    });
  };

  handleToggleEmailNotification = (row) => {
    const newValue = !row.receive_email;
    this.props
      .protectedFetch(
        config.backendServer + `employee/${row.id}/`,
        "PATCH",
        { receive_email: newValue },
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        this.setState((prev) => ({
          employee: prev.employee.map((emp) =>
            emp.id === row.id ? { ...emp, receive_email: newValue } : emp,
          ),
        }));
      })
      .catch(() => {
        console.log("fail");
      });
  };

  handleRowClick = (id) => {
    const history = createBrowserHistory({ forceRefresh: true });
    history.push(`/staff-detail/${id}`);
    // alert("row");
  };
  render() {
    // const rows = this.props.data;
    const headCells = this.props.head;
    Modal.setAppElement("body");

    if (this.state.loading) {
      return <LoadingPage />;
    }

    return (
      <div>
        <div className="d-flex justify-content-end mb-4">
          <div className="col-3 input-group pr-0">
            <input
              type="text"
              placeholder="Search Staff"
              id={"searchFilter"}
              className={"form-control"}
              onChange={this.searchChange}
              value={this.state.searchFilter}
              onKeyDown={this.onKeyDown}
              width={"70px"}
            />
            <div className="input-group-prepend">
              <span className="form-control ">
                <i className="fa fa-search form-control-icon"></i>
              </span>
            </div>
          </div>
        </div>

        <TableContainer>
          <MaterialTable
            aria-labelledby="tableTitle"
            size={"small"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              order={this.state.order}
              orderBy={this.state.orderBy}
              onRequestSort={this.handleRequestSort}
              headCells={this.props.head}
              selectStatus={this.props.statusSelectors}
              filterStatus={this.props.filteredStatus}
            />
            <TableBody>
              {this.state.employee && this.state.employee.length > 0 ? (
                this.state.employee.map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow tabIndex={-1} key={labelId}>
                      {/* Loop through head to get data order */}
                      {headCells.map((item, i) => {
                        if (item.id === "action") {
                          return (
                            <TableCell
                              style={{
                                cursor: "pointer",
                                maxWidth: "250px",
                                wordWrap: "break-word",
                              }}
                              key={i}
                            >
                              <div className="d-flex align-items-center gap-2 flex-wrap">
                                <span
                                  onClick={() =>
                                    this.handleOpenModalSendPassword(
                                      row.email,
                                      "Are you sure you want to send a password reset to",
                                    )
                                  }
                                  className={"btn btn-outline-danger btn-sm"}
                                >
                                  Reset Password
                                </span>
                                <span
                                  onClick={() =>
                                    this.handleToggleEmailNotification(row)
                                  }
                                  className={`btn btn-sm ${row.receive_email ? "btn-success" : "btn-outline-secondary"}`}
                                  title={
                                    row.receive_email
                                      ? "Email notification ON — click to disable"
                                      : "Email notification OFF — click to enable"
                                  }
                                >
                                  {row.receive_email
                                    ? "Email Notif: ON"
                                    : "Email Notif: OFF"}
                                </span>
                              </div>
                            </TableCell>
                          );
                        } else if (item.id === "brands") {
                          let names = item
                            ?.valueDisplay(row[item?.id])
                            .map((items) => items.name);
                          return (
                            <TableCell
                              key={i}
                              style={{
                                maxWidth: "200px",
                                wordWrap: "break-word",
                              }}
                            >
                              {names.join(", ")}
                            </TableCell>
                          );
                        } else if (item.id === "name") {
                          return (
                            <TableCell
                              key={i}
                              style={{
                                maxWidth: "200px",
                                wordWrap: "break-word",
                              }}
                            >
                              <Link to={"/staff-detail/" + row.id}>
                                {item?.valueDisplay(row[item?.id])}
                              </Link>
                            </TableCell>
                          );
                        } else if (item.id === "service_center") {
                          return (
                            <TableCell
                              key={i}
                              style={{
                                width: 100,
                                wordWrap: "break-word",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                row.service_center.length > 0 &&
                                this.setState({
                                  showServiceCenter: true,
                                  staff: row,
                                })
                              }
                            >
                              {row.service_center.length > 0 ? (
                                <u className="text-primary">
                                  {row.service_center.length}
                                </u>
                              ) : (
                                <span>-</span>
                              )}
                            </TableCell>
                          );
                        } else {
                          return (
                            <TableCell
                              key={i}
                              style={
                                item?.width
                                  ? {
                                      maxWidth: item?.width,
                                      wordWrap: "break-word",
                                    }
                                  : {
                                      maxWidth: "120px",
                                      wordWrap: "break-word",
                                    }
                              }
                            >
                              {item?.valueDisplay(row[item?.id])}
                            </TableCell>
                          );
                        }
                      })}
                    </TableRow>
                  );
                })
              ) : (
                <div>No staff</div>
              )}
            </TableBody>
          </MaterialTable>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 25, 100]}
          component="div"
          count={this.state.totalEmployee || 0}
          rowsPerPage={this.state.rowPerPage}
          page={this.state.pageNumber - 1}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
        />

        <Modal
          isOpen={this.state.showModal}
          //onRequestClose={()=>this.setState({showDeclineModal: false})}
          contentLabel={"Add Note"}
          className={
            "confirm-modal confirm-modal-big-approve warranty-decline-modal"
          }
        >
          <button
            onClick={() => this.setState({ showModal: false })}
            className={"confirm-modal-close"}
          >
            <MdClose />
          </button>
          <form onSubmit={this.handleSubmitAssign}>
            <div className={"approveDeclineSet confirmApproveDeclineSet"}>
              <div className={"form-field"}>
                <div className="mb-3">Confirm Assigned?</div>
                <button type="submit" className={"approve confirmDecline"}>
                  Assign
                </button>
                <button
                  type={"button"}
                  className={"neutral confirmNeutral"}
                  onClick={() => this.setState({ showModal: false })}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </Modal>

        <Modal
          isOpen={this.state.showModalResetPassword}
          contentLabel={"Reset Password"}
          className={
            "confirm-modal confirm-modal-big-approve warranty-decline-modal"
          }
        >
          <button
            onClick={() => this.setState({ showModalResetPassword: false })}
            className={"confirm-modal-close"}
          >
            <MdClose />
          </button>
          <form>
            <div className={"approveDeclineSet confirmApproveDeclineSet"}>
              <div className={"form-field"}>
                <div className="mb-3">{`${this.state.modalCaption} ${this.state.emailForReset}?`}</div>
                <button
                  type="button"
                  className={"approve confirmDecline"}
                  onClick={(event) => {
                    if (this.state.modalCaption.toLowerCase().includes("reset"))
                      this.handleResetPassword();
                    else this.handleSendVerification(event);
                  }}
                >
                  Send
                </button>
                <button
                  type={"button"}
                  className={"neutral confirmNeutral"}
                  onClick={() =>
                    this.setState({ showModalResetPassword: false })
                  }
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </Modal>

        <Modal
          isOpen={this.state.showModalResetPasswordSuccess}
          contentLabel={"Reset Password"}
          className={
            "confirm-modal confirm-modal-big-approve warranty-decline-modal"
          }
        >
          <form>
            <div className={"approveDeclineSet confirmApproveDeclineSet"}>
              <div className={"form-field"}>
                <div className="mb-3">
                  The reset password email is sent to {this.state.emailForReset}
                </div>
                <button
                  type={"button"}
                  className={"neutral confirmNeutral"}
                  onClick={() =>
                    this.setState({
                      showModalResetPasswordSuccess: false,
                      showModalResetPassword: false,
                    })
                  }
                >
                  Close
                </button>
              </div>
            </div>
          </form>
        </Modal>

        {/* Modal for confirm status ticket type */}
        <Modal
          isOpen={this.state.modalStatus}
          contentLabel={"Set as Out of Warranty"}
          className={"confirm-modal"}
        >
          <form onSubmit={this.handleChangeStatusTicketType}>
            <div className={"approveDeclineSet confirmApproveDeclineSet"}>
              <div className={"form-field"}>
                <div className="mb-3">
                  Change Status to {this.state.statusTicketType}?
                </div>
                <button type="submit" className={"approve confirmDecline"}>
                  Confirm
                </button>
                <button
                  type={"button"}
                  className={"neutral confirmNeutral"}
                  onClick={this.handleCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </Modal>
        <Modal isOpen={this.state.showServiceCenter} className={"input-modal"}>
          <div className="card">
            <div className="card-header">{`${this.state.staff?.name} - service center list`}</div>
            <div className="card-body">
              <ul className="list-group">
                {this.state.staff?.service_center?.map((sc, i) => {
                  return (
                    <li className="list-group-item" key={i}>{`${i + 1}.  ${
                      sc.name
                    }`}</li>
                  );
                })}
              </ul>
            </div>
            <div className="card-footer">
              <button
                type={"button"}
                className={"btn btn-outline-secondary"}
                onClick={() => this.setState({ showServiceCenter: false })}
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
